import { AutocompleteArrayInput, ReferenceArrayInput } from 'react-admin'

const GroupMembersInput = ({ source, reference }) => (
  <ReferenceArrayInput reference={reference} source={source}>
    <AutocompleteArrayInput filterToQuery={(search_designation) => ({ search_designation })} />
  </ReferenceArrayInput>
)

export default GroupMembersInput
